import React from 'react';
import { motion } from 'framer-motion';
const treatments = [{
  title: 'Chemical Peel',
  desc: 'Smooth texture, fade discoloration, and refresh tone with a customized peel.',
  img: 'https://cdn.magicpatterns.com/uploads/gXmtEuimYtf8U6nmDud7Q8/Chemical_Peel.png'
}, {
  title: 'Facial Balancing w/ Filler',
  desc: 'Subtle contouring and proportion through expert filler placement.',
  img: 'https://cdn.magicpatterns.com/uploads/unEyJLRNt6PCPphSL6zQdG/Facial_Balancing_W__Filler.png'
}, {
  title: 'IPL Photofacial',
  desc: 'Target sun damage, redness, and pigmentation for a clearer complexion.',
  img: 'https://cdn.magicpatterns.com/uploads/rLzkB89XkbCp7x9NZa9x1r/IPL.jpg'
}, {
  title: 'Custom Treatment Plan',
  desc: 'Your skin, your plan. We map out exactly what you need.',
  img: null
}];
export const TreatmentGallery = () => {
  return <section className="w-full bg-be-navy py-20 px-4" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        <h2 className="text-center text-white font-bold text-2xl sm:text-3xl tracking-[0.1em] uppercase mb-12" data-id="element-142">
          What you can book with your credit
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-143">
          {treatments.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="group cursor-pointer" data-id="element-144">
              <div className="w-full aspect-square rounded-xl overflow-hidden mb-4 bg-be-navy-light relative" data-id="element-145">
                {t.img ? <img src={t.img} alt={t.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-146" /> : <div className="w-full h-full bg-gradient-to-br from-be-pink/20 to-be-navy flex items-center justify-center p-6 text-center" data-id="element-147">
                    <span className="text-be-pink font-script text-3xl opacity-80" data-id="element-148">
                      Your skin,
                      <br data-id="element-149" />
                      your plan
                    </span>
                  </div>}
              </div>
              <h3 className="text-white font-bold uppercase tracking-wider mb-2 text-sm" data-id="element-150">
                {t.title}
              </h3>
              <p className="text-white/70 text-sm leading-relaxed" data-id="element-151">{t.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};